(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('price-range-slider')) {
    class PriceRangeSlider extends HTMLElement {
      constructor() {
        super();
        this.minInput = this.querySelector('[data-price-input="min"]');
        this.maxInput = this.querySelector('[data-price-input="max"]');
        this.minSlider = this.querySelector('[data-price-slider="min"]');
        this.maxSlider = this.querySelector('[data-price-slider="max"]');
        this.sliderRange = this.querySelector('[data-slider-range]');
        
        // Shopify stores prices in cents
        this.rangeMin = parseInt(this.dataset.rangeMin) || 0;
        this.rangeMax = parseInt(this.dataset.rangeMax) || 100000;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        if (!this.minInput || !this.maxInput || !this.minSlider || !this.maxSlider) {
          return;
        }

        // Slider listeners - update inputs while dragging
        this.minSlider.addEventListener('input', () => {
          this.syncSliderToInput(this.minSlider, this.minInput, 'min');
        });

        this.maxSlider.addEventListener('input', () => {
          this.syncSliderToInput(this.maxSlider, this.maxInput, 'max');
        });

        // Trigger change event when slider is released
        this.minSlider.addEventListener('change', () => {
          document.querySelector('facet-inputs-component').dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.maxSlider.addEventListener('change', () => {
          document.querySelector('facet-inputs-component').dispatchEvent(new Event('change', { bubbles: true }));
        });

        // Input listeners - update sliders when typing
        this.minInput.addEventListener('input', () => {
          this.syncInputToSlider(this.minInput, this.minSlider);
        });

        this.maxInput.addEventListener('input', () => {
          this.syncInputToSlider(this.maxInput, this.maxSlider);
        });

        // Initialize visual range
        this.updateSliderRange();
      }

      syncSliderToInput(slider, input, type) {
        let valueInCents = parseInt(slider.value);
        const otherValueInCents = parseInt(type === 'min' ? this.maxSlider.value : this.minSlider.value);

        // Prevent sliders from crossing
        if (type === 'min' && valueInCents > otherValueInCents) {
          valueInCents = otherValueInCents;
          slider.value = valueInCents;
        } else if (type === 'max' && valueInCents < otherValueInCents) {
          valueInCents = otherValueInCents;
          slider.value = valueInCents;
        }

        // Convert cents to display value (dollars/euros/etc)
        const displayValue = (valueInCents / 100).toFixed(2).replace(/\.?0+$/, '');
        input.value = displayValue;
        this.updateSliderRange();
      }

      syncInputToSlider(input, slider) {
        const displayValue = this.parseValue(input.value);
        if (displayValue !== null) {
          // Convert display value to cents
          const valueInCents = Math.round(displayValue * 100);
          slider.value = valueInCents;
          this.updateSliderRange();
        }
      }

      updateSliderRange() {
        if (!this.sliderRange) return;

        const minVal = parseInt(this.minSlider.value);
        const maxVal = parseInt(this.maxSlider.value);

        const minPercent = ((minVal - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
        const maxPercent = ((maxVal - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;

        this.sliderRange.style.left = Math.max(0, minPercent) + '%';
        this.sliderRange.style.width = Math.max(0, maxPercent - minPercent) + '%';
      }

      parseValue(value) {
        if (!value || value === '') return null;
        const cleaned = value.toString().replace(/[^\d.]/g, '');
        const parsed = parseFloat(cleaned);
        return isNaN(parsed) ? null : parsed;
      }
    }

    customElements.define('price-range-slider', PriceRangeSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
